import React from 'react';
import PropTypes from 'prop-types';

import ActionsItemText from './ActionsItemText';
import DateTime from '../DateTime';

const UserProfileActionsItem = ({ action, ...props }) => (
  <tr>
    <td className="user-profile-action-title">
      <ActionsItemText action={action} {...props} />
    </td>
    <td className="user-profile-action-date">
      <DateTime
        id={`user-action-date-${action.id}`}
        dateTime={action.created_at}
      />
    </td>
  </tr>
);

UserProfileActionsItem.propTypes = {
  action: PropTypes.object.isRequired,
};

export default UserProfileActionsItem;
